import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { EditAttendanceModalLayout } from '../ModalLayout'

class EditAttendance extends Component {
    constructor() {
        super()
        this.state = {
            isEditAttendanceModalOpened: false,
        }
    }
    opeEditAttendanceModal = () => {
        this.setState({ isEditAttendanceModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isEditAttendanceModalOpened: status })
    }

    render() {
        let modalComponent = null

        if (this.state.isEditAttendanceModalOpened) {
            modalComponent =
                <HBBModal>
                    <EditAttendanceModalLayout data={this.props.data}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div style={{width:"106%"}}>
            {modalComponent}

                <button
                    className="attendance-edit-btn btn btn-primary button-custom"
                     onClick={(e) => {
                        e.preventDefault()
                        this.opeEditAttendanceModal()
                    }}>
                    <i class="fa fa-pencil-square-o"><i> </i>Edit</i>
                </button>
                
            </div>
        )
    }
}

export default EditAttendance


// WEBPACK FOOTER //
// ./src/modules/Attendance/Components/ActionButtons/EditAttendance.js